import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import { useForm } from "react-hook-form";
import Content from "../../layout/content/Content";
import { Block, Col, DataTable, PreviewAltCard, Row } from "../../components/Component";
import { Form, Offcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";

import {
  createBrandAPI,
  createCouponAPI,
  listBrandAPI,
  listCouponAPI,
  updateBrandAPI,
  updateCouponAPI,
} from "../../api/master/indes";

import { toast } from "react-toastify";

import { BASE_URL_IMG } from "../../assets/constants";
import MyButton from "../../MyComp/UI/form/MyButton";
import ViewImage from "../../MyComp/UI/modals/ViewImage";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import MyInput from "../../MyComp/UI/form/MyInput";
import Status from "../../MyComp/UI/form/Status";
import { productDDAPI } from "../../api/dropdown";

import moment from "moment";
import useLogout from "../../hooks/useLogout";
import MySelect from "../../MyComp/UI/form/MySelect";
import MyDate from "../../MyComp/UI/form/MyDate";
import MyTextArea from "../../MyComp/UI/form/MyTextArea";
import Table from "../../MyComp/UI/DataTable/Table";
const Coupon = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      data: [],
      meta_image: null,
      meta_img: null,
      product_banner_img: null,
      product_banner_image: null,
      product_images: [],
      productTypeDD: [],
      brandsDD: [],
      categoryDD: [],
      unitDD: [],
      ingredientDD: [],
      diseaseDD: [],
      isPub: false,
    },
  });
  const logout = useLogout();

  const [isOpen, setIsOpen] = useState(false);
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const [data, setData] = useState([]);

  const toggleCanvas = () => {
    setIsOpen((prev) => !prev);
    if (isOpen) resetForm();
  };
  const handleImageOpenPreview = (row) => {
    setImageOpen(!imageOpen);
    setValue("image_preview", row);
    trigger("image_preview");
  };
  const selectorCheck = (e) => {
    const updated = data.map((item) => ({ ...item, checked: e.target.checked }));
    setData(updated);
  };
  const handleTogglePublish = (row) => {
    setValue("isPub", true);
    setValue("selectedRow", row);
    setShowModal(true);
  };

  const selectorDeleteUser = () => setData(data.filter((d) => !d.checked));

  useEffect(() => {
    getProductList();
    getCouponList();
  }, []);
  const getProductList = () => {
    productDDAPI()
      .then((res) => {
        console.log("response list product", res);
        //const status = decrypt(res.data.status);
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        } else if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("productList", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("productList", []);
          toast.error(!res.data.message);
          toast.clearWaitingQueue();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err.message);
      });
  };
  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };
  const getCouponList = () => {
    listCouponAPI()
      .then((res) => {
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else if (res.data.status === true) {
          setData(res.data.data);
          setValue("isLoading", false);
        } else {
          setData([]);
          setValue("isLoading", false);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err.message);
      });
  };
  const resetForm = () => {
    setValue("status", "");
    setValue("selectedRow", "");
    setMode("Add");
    setValue("max_discount", "");
    setValue("start_date", null);
    setValue("exp_date", null);
    setValue("coupon_count", "");
    setValue("coupon_count", "");
    setValue("min_amount", "");
    setValue("coupon_name", "");
    setValue("product", "");
    setValue("usage_per_user", "");
    setValue("description", "");
  };
  const onFormSubmit = (data) => {
    const body = {
      start_time: moment(data?.start_date).format("MM/DD/yyyy h:mm A"),
      end_time: moment(data?.exp_date).format("MM/DD/yyyy h:mm A"),
      usage_per_user: watch("usage_per_user") || null,
      min_amount: watch("min_amount"),
      product_id: watch("product")?.value || null,
      max_discount: watch("max_discount"),
      coupon_name: watch("coupon_name"),
      coupon_count: watch("coupon_count"),
      description: watch("description"),
      status: watch("status")?.value,
      ...(mode == "Edit" && { id: watch("selectedRow")?.id }),
    };
    console.log("data", data, body);
    if (mode == "Add") {
      createCouponAPI(body)
        .then((res) => {
          //const status = decrypt(res.data.status);
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getCouponList();
            setIsOpen(false);
            setValue("isLoading", false);
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err.message);
        });
    }
    if (mode == "Edit") {
      updateCouponAPI(body)
        .then((res) => {
          //const status = decrypt(res.data.status);
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getCouponList();
            setIsOpen(false);
            setValue("isLoading", false);
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err.message);
        });
    }
  };
  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    setValue("selectedRow", row);
    setIsOpen(true);
    setMode("Edit");
    setValue("status", row?.status ? { label: "Active", value: true } : { label: "InActive", value: false });
    setValue("max_discount", row?.max_discount);
    setValue("start_date", new Date(row?.start_time));
    setValue("exp_date", new Date(row?.end_time));
    setValue("coupon_count", row?.coupon_count);
    setValue("usage_per_user", row?.usage_per_user);
    setValue("min_amount", row?.min_amount);
    setValue("coupon_name", row?.coupon_name);
    setValue("product", row?.products);
    setValue("description", row?.description);
  };
  const confirmStatusChange = (data) => {
    const updatedStatus = watch("selectedRow").status === true ? false : true;
    setValue("isLoading", true);
    const formObject = {
      id: watch("selectedRow").id,
      status: updatedStatus,
    };
    updateCouponAPI(formObject)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          listCouponAPI();
          setIsOpen(false);
          resetForm();
          setValue("isLoading", false);
          setShowModal(false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err.message);
      });
  };
  const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };

  const onSelectChange = (e, id) => {
    const updated = data.map((item) => (item.id === id ? { ...item, checked: e.target.checked } : item));
    setData(updated);
  };
  const selectorSuspendUser = () => setData(data.map((d) => (d.checked ? { ...d, status: false } : d)));

  return (
    <>
      <Head title={"Product | Master"} />
      <Content>
        {/* <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Manage Products"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    resetF();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead> */}
        <Block>
          <>
            {" "}
            <div className="container my-5 text-center">
              {/* Button to open offcanvas */}

              <Offcanvas isOpen={isOpen} direction="end">
                <OffcanvasHeader toggle={toggleCanvas}>Coupon </OffcanvasHeader>
                <OffcanvasBody>
                  <PreviewAltCard>
                    <Form onSubmit={handleSubmit(onFormSubmit)}>
                      <Row>
                        <Col md="12" className={``}>
                          <MySelect
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                            title={"Product Specific Coupon"}
                            name={"product"}
                            placeholder={"Select if coupon is product specific"}
                            options={watch("productList")}
                            isClear
                          />
                        </Col>
                        <Col md="12" className={``}>
                          <MyInput
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                            title={"Name"}
                            name={"coupon_name"}
                            placeholder={"Enter coupon name"}
                            required
                            min={2}
                            max={50}
                          />
                        </Col>
                        <Col md="12" className={``}>
                          <MyInput
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                            title={"Minimum Amount"}
                            name={"min_amount"}
                            placeholder={"Enter minimum amount to avail coupon"}
                            required
                            min={1}
                            max={3}
                          />
                        </Col>
                        <Col md="12" className={``}>
                          <MyInput
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                            title={"Maximum Discount"}
                            name={"max_discount"}
                            placeholder={"Enter maximum discount to avail"}
                            required
                            min={1}
                            max={3}
                          />
                        </Col>
                        <Col md="12" className={``}>
                          <MyDate
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                            title={"Start Date"}
                            name={"start_date"}
                            placeholder={"Enter start date"}
                            required
                            min={moment().startOf("day").toDate()}
                            max={moment().add(1, "years").toDate()}
                            time
                            format={"MM/dd/yyyy h:mm aa"}
                            control={control}
                          />
                        </Col>
                        <Col md="12" className={``}>
                          <MyDate
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                            title={"Expiry Date"}
                            name={"exp_date"}
                            placeholder={"Enter expiry date"}
                            required
                            min={moment().endOf("day").toDate()}
                            max={moment().add(1, "years").toDate()}
                            time
                            format={"MM/dd/yyyy h:mm aa"}
                            control={control}
                          />
                        </Col>
                        <Col md="12" className={``}>
                          <MyInput
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                            title={"Max Usage Count Per User"}
                            name={"usage_per_user"}
                            placeholder={"Enter usage count per user"}
                            min={1}
                            max={3}
                          />
                        </Col>
                        <Col md="12" className={``}>
                          <MyInput
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                            title={"Total Coupon"}
                            name={"coupon_count"}
                            placeholder={"Enter total available coupon"}
                            required
                            min={1}
                            max={3}
                          />
                        </Col>
                        <Col md={`12`}>
                          <Status
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                          />
                        </Col>
                        <Col md="12" className={``}>
                          <MyTextArea
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                            title={"Description"}
                            name={"description"}
                            placeholder={"Enter description"}
                            required
                            min={25}
                            max={100}
                            cols={2}
                            row={2}
                          />
                        </Col>
                      </Row>
                      <Col md="12" className={``}>
                        <div className="form-group" style={{ marginTop: "31px" }}>
                          <MyButton isLoading={isLoading} mode={mode} />
                        </div>
                      </Col>
                    </Form>
                  </PreviewAltCard>
                </OffcanvasBody>
              </Offcanvas>

              {/* Offcanvas (Right Side) */}
            </div>
          </>

          <Table
            title="Coupon List"
            data={data}
            publicButton={false}
            const
            columns={[
              { key: "coupon_name", label: "Name" },
              { key: "products.label", label: "Product" },
              { key: "min_amount", label: "Min Amount" },
              { key: "max_discount", label: "Max Discount" },
              //   { key: "discount_type", label: "Discount Type" },
              { key: "start_time", label: "Start" },
              { key: "end_time", label: "Expiry" },
              { key: "usage_per_user", label: "Usage / User" },
              { key: "coupon_count", label: "Available Coupons" },

              //   { key: "description", label: "Description" },

              //   { key: "updatedAt", label: "Updated At" },
            ]}
            searchKeys={["product", "coupon_name"]}
            nameColumn={"coupon_name"}
            imageBaseURL={BASE_URL_IMG}
            onEditClick={handleEdit}
            selectorCheck={selectorCheck}
            selectorDeleteUser={selectorDeleteUser}
            selectorSuspendUser={selectorSuspendUser}
            onSelectChange={onSelectChange}
            statusFilterEnabled={true}
            isOpen={isOpen}
            confirmStatusChange={confirmStatusChange}
            setIsOpen={setIsOpen}
            resetF={resetForm}
            handleImageOpenPreview={handleImageOpenPreview}
            handleToggleStatus={handleToggleStatus}
            toggleCanvas={toggleCanvas}
            handleTogglePublish={handleTogglePublish}
          />

          {/* <MyDataTable data={data || []} columns={column} title={"Product List"} isLoading={isLoading} /> */}
        </Block>
      </Content>
      <ViewImage url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
      <ConfirmModal
        isOpen={showModal}
        toggle={() => {
          setShowModal(!showModal);
          setValue("isPub", false);
        }}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
        isPub={watch("isPub")}
        data={watch("selectedRow")}
      />
    </>
  );
};

export default Coupon;
